import React from "react";

export const ApplicationLoader = () => {
  return (
    <div className="loader">
      <div className="spinner" />
    </div>
  );
}
